export const REACT_APP_SUPABASE_URL =
  'https://yebacysnkfswprdbkoyj.supabase.co';
export const REACT_APP_SUPABASE_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InllYmFjeXNua2Zzd3ByZGJrb3lqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTI3NTk5MDksImV4cCI6MjAyODMzNTkwOX0.qxtAAM6X8pNJXHOjyKZS25vjIlkwVYLj3eh9uLeCVHE';
